import { createSelector } from 'reselect';

const postbacks = (state) => state.postbacks.list.data;

export const getPostback = createSelector(
    postbacks,
    (postbacks = []) => {
        return postbacks[0] && postbacks[0].config;
    }
);
